/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui';



/* ++++++++++ --------------- EMOJI - CONFIGURATION PAGE : STYLES --------------- ++++++++++ */
export default {
    emojiconfig: {
        '& .emojilist': {
            marginTop: pxToEm(2),
            fontSize: '90%',
            '& .emojiicon': {
                margin: replacePXinStringWithEM('0 2px')
            }
        },
        '& .messagecard': {
            padding: replacePXinStringWithEM('10px'),
            '& .name-emojimessage': {
                margin: '0'
            }
        },
        '& table.emojidata': {
            borderCollapse: 'collapse',
            borderRadius: pxToEm(12),
            width: '100%',
            tableLayout: 'fixed',
            '& tr': {
                '& th': {
                    background: 'rgb(246, 247, 249)',
                    borderTop: replacePXinStringWithEM('1px solid rgb(216, 217, 230)'),
                    borderBottom: replacePXinStringWithEM('1px solid rgb(216, 217, 230)'),
                    fontSize: pxToEm(18),
                    fontWeight: 'normal',
                    padding: replacePXinStringWithEM('10px 34px'),
                    '&:nth-child(1)': {
                        width: '15%',
                        borderLeft: replacePXinStringWithEM('1px solid rgb(216, 217, 230)'),
                    },
                    '&:nth-child(2)': {
                        width: '15%',
                    },
                    '&:nth-child(3)': {
                        width: '30%',
                    },
                    '&:nth-child(4)': {
                        width: '30%',
                        borderRight: replacePXinStringWithEM('1px solid rgb(216, 217, 230)')
                    },
                    '& > div': {
                        width: '100%',
                    },
                },
            }
        },
        '& .selectWrapper': {
            position: 'relative',
            display: 'inline-block',
            maxWidth: '100%',

            '& i': {
                top: pxToEm(4),
                right: 0,
                position: 'absolute',
                color: 'rgb(6, 43, 117)',
                zIndex: 100,
                fontSize: pxToEm(12, 17),
            },

            '& .SelectField, & .SelectField:focus,  & .SelectField:focus-visible': {
                background: 'none',
                height: '100%',
                width: '100%',
                border: 'none',
                color: 'rgb(6, 43, 117)',
                fontSize: '18px',
                fontWeight: '400',
                outline: 'none',
                '-webkit-appearance': 'none',
                appearance: 'none',
                paddingRight: '1em',
            }
        },
        '& .emojidropdown': {
          '& .placeholder': {
            background: 'transparent',
            border: 0
          } 
        }
    }
};
